export const defaultConfig = {
  hotelId: null,
  apiKey: null,
  colorTheme: 'light', // 'light' | 'dark'
  triggers: {
    order: ['destination', 'calendar', 'guests', 'promo'],
    shape: 'pill', // 'pill' | 'square'
    showIconLeft: false,
    showIconRight: false,
    // type: 'labeled',
    // labels: { calendar: 'Date Range' },
  },
  popoutDirection: 'top', // 'top' | 'bottom'
  detectPopoutDirection: false,
  hotelPreselected: false,
  calendar: {
    startDate: null,
    endDate: null,
    showPrices: true,
  },
  styles: null,
  theme: {
    tokens: {
      breakpoints: {
        small: {
          size: 768,
        },
        medium: {
          size: 768,
        },
        large: {
          size: 1024,
        },
      },
    },
  },
};
